module.exports = __webpack_public_path__ + "static/media/Warning_Symbol@3x.9c987bf2.png";